import classnames from "@src/utils/classnames"
import React, { useEffect, useRef } from "react"
import Clickable from "../clickable"
import * as styles from "./card.module.scss"
import { throttle } from "lodash"

const createMsgBox = () => {
  const msgId = "ttt_msg"
  let msgDom = window.document.querySelector(`#${msgId}`)
  if (!msgDom) {
    const div = window.document.createElement("div")
    div.setAttribute("id", "ttt_msg")
    div.style.position = "fixed"
    div.style.zIndex = "99999"
    div.style.left = "0px"
    div.style.top = "0px"
    div.style.color = "black"
    div.style.backgroundColor = "white"
    div.style.whiteSpace = "pre"
    window.document.querySelector("body").prepend(div)

    msgDom = div
  }

  return msgDom
}

const Card = ({
  // colors
  lightBg,
  lightHBg,
  squareBg,
  activeBg,

  // deprecated
  tipColor,
  red,

  // struct style
  tipStyle,
  mobileCenter,

  // color modify
  // deprecated
  tintTitle,
  tint,

  title,
  body,
  media,
  bigMedia,
  extra,
  children,
  className,
  forcePerspective,

  disableBorderAnimation = false,

  ...props
}) => {
  const cardRef = useRef()

  useEffect(() => {
    // const msgDom = createMsgBox()
    const card = cardRef.current

    if (
      forcePerspective === false ||
      !(
        card.getAttribute("role") ||
        card.getAttribute("href") ||
        forcePerspective === true
      )
    ) {
      return
    }

    const setPerspect = (
      { x, y, z },
      { x: offsetX, y: offsetY },
      scale = 1
    ) => {
      card.style.transform = `perspective(var(--_perspective)) rotateX(${x}deg)
      rotateY(${y}deg) rotateZ(${z}deg) scale(${scale}) translate(${offsetX}px, ${offsetY}px)`
    }

    const calcPerspect = (offset, length, limit) => {
      const half = length / 2
      const margin = Math.abs(half - offset)
      const result = (limit * margin) / half
      return half > offset ? result : -result
    }

    const enterEvent = throttle((e) => {
      const { left: cardX, top: cardY } = card.getBoundingClientRect()
      const layerX = e.clientX - cardX
      const layerY = e.clientY - cardY

      // msgDom.innerHTML = [
      //   `container: ${card.offsetWidth}, ${card.offsetHeight}, ${cardX}, ${cardY}`,
      //   `client: ${e.clientX}, ${e.clientY}`,
      //   `page: ${e.pageX}, ${e.pageY}`,
      //   `layer: ${layerX}, ${layerY}`,
      // ].join("\n")

      const angle = 3
      let [x, y, z] = [0, 0, 0]
      y = -calcPerspect(layerX, card.offsetWidth, angle)
      x = calcPerspect(layerY, card.offsetHeight, angle)

      const offset = 5
      const offsetX = -calcPerspect(layerX, card.offsetWidth, offset)
      const offsetY = -calcPerspect(layerY, card.offsetHeight, offset)
      // if (layerX < card.offsetWidth / 3) {
      //   y = -angle
      // } else if (layerX > (card.offsetWidth * 2) / 3) {
      //   y = angle
      // }
      // if (layerY < card.offsetHeight / 3) {
      //   x = angle
      // } else if (layerY > (card.offsetHeight * 2) / 3) {
      //   x = -angle
      // }

      setPerspect({ x, y, z }, { x: offsetX, y: offsetY }, 1.02)
    }, 200)
    const outEvent = () => {
      setTimeout(() => {
        setPerspect({ x: 0, y: 0, z: 0 }, { x: 0, y: 0 })
      }, 300)
    }
    card.addEventListener("mousemove", enterEvent)
    card.addEventListener("mouseleave", outEvent)

    return () => {
      card.removeEventListener("mousemove", enterEvent)
      card.removeEventListener("mouseleave", outEvent)
    }
  }, [forcePerspective])

  const content = children || (
    <>
      <div className={styles.top}>
        {title && <h3 className={styles.title}>{title}</h3>}
        {media && <span className={styles.media}>{media}</span>}
      </div>
      <div className={classnames(styles.bottom, "e_card_bottom")}>
        {body && (
          <div className={classnames(styles.body, "e_card_body")}>{body}</div>
        )}
        {extra && <div className={styles.extra}>{extra}</div>}
      </div>
    </>
  )
  return (
    <Clickable
      {...props}
      ref={cardRef}
      className={classnames(
        "e_card",
        styles.container,
        {
          [styles.lightBg]: lightBg,
          [styles.lightHBg]: lightHBg,
          [styles.squareBg]: squareBg,
          [styles.activeBg]: activeBg,
          // [styles.red]: red,
          // [styles.tipColor]: tipColor,

          [styles.tipStyle]: tipStyle,
          [styles.mobileCenter]: mobileCenter,

          // [styles.tint]: tint,
          // [styles.tintTitle]: tintTitle,

          [styles.disableBorderAnimation]: disableBorderAnimation,
        },
        className
      )}
    >
      <div className={classnames(styles.main, "e_card_main")}>{content}</div>
      {bigMedia && <div className={styles.bigMedia}>{bigMedia}</div>}
    </Clickable>
  )
}

export default Card
